import { Route, Routes } from 'react-router'

import ToApp from './ToApp'

const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<ToApp />} />
    </Routes>
  )
}

export default AuthRoutes
